export default __webpack_public_path__ + "static/media/defaultFlower.2f779b14.jpg";